/**
 * @param {string} str
 * @returns {Boolean}
 * 
 */
export function validUsername(str) {
  const valid_map=['admin','editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} phone
 * @return {boolean}
 */
export function validPhone(phone) {
  const reg=/^1[3456789]\d{9}$/
  return reg.test(phone)
}

/**
 * @param {string} path
 * @return {boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}





// WEBPACK FOOTER //
// ./src/utils/validate.js